import TemplateChecklistReadComponent, {
  TemplateCheckListReadComponentProps,
} from './TemplateChecklistReadComponent';

export default TemplateChecklistReadComponent;

export type { TemplateCheckListReadComponentProps };
